<template>
  <div class="px-1" :class="$vuetify.breakpoint.mobile ? 'mt-6' : 'mt-4'">
    <v-divider></v-divider>
    <v-footer class="rounded-lg rounded-t-0 pb-0 caption text-justify">
      <p v-if="currentPaymentProvider === 'PixPay4FunGO'">
        {{ $t("pay4funDepositFooterText1") }}
        <strong>{{ operatorName }}</strong
        >.
        <br />
        <br />
        {{ $t("pay4funDepositFooterText2") }}
      </p>

      <p v-else-if="currentPaymentProvider === 'CarteiraPay4FunWallet'">
        {{ $t("walletPay4FunFooter1") }}
        <strong>{{ operatorName }}</strong>
        {{ $t("walletPay4FunFooter2") }}
        <br />
        {{ $t("walletPay4FunFooter2_1") }}
      </p>

      <p
        v-else-if="
          currentPaymentProvider === 'PixPaybrokers' ||
            currentPaymentProvider === 'PixPaybrokersV4'
        "
      >
        {{ $t("paybrokersFooter1") }}
        {{ $t("paybrokersFooter2") }}
      </p>

      <p v-else-if="currentPaymentProvider === 'PixBrasilCash'">
        {{ $t("brazilCashFooter") }}
        <br />
        {{ $t("brasilCashFooter2") }}
      </p>

      <p v-else-if="currentPaymentProvider === 'PixLanceCerto'">
        {{ $t("pixlancecertoFooter") }}
      </p>

      <!-- ClinPays -->
      <p v-else-if="currentPaymentProvider === 'CartãoClinPays'">
        {{ $t("clinPaysFooter") }}
      </p>

      <p v-else-if="currentPaymentProvider === 'PixPaag'">
        {{ $t("paagFooter") }}
      </p>

      <p v-else-if="currentPaymentProvider === 'PixPaguePay'">
        <!-- substituir por texto PaguePay -->
        {{ $t("paguePayFooter") }}
      </p>

      <p v-else-if="currentPaymentProvider === 'PixPagFast'">
        {{ $t("pagFastFooter") }}
      </p>
    </v-footer>
  </div>
</template>
<script>
export default {
  props: ["currentPaymentProvider"],
  computed: {
    operatorName() {
      return this.$store.state.operators.operator_name;
    },
  },
};
</script>